export default {
    unlock: 'hordeClassCultist',
    icon: 'mdi-pentagram',
    baseStats: {
        attack: 3.3,
        health: 700
    },
    exp: {
        base: 12600,
        increment: 1.875
    },
    skills: {},
    skillTree: [
        {isInnate: true, level: 0, items: []},
    ],
    quests: {
        stat: [],
        zone: [],
        level: [],
        boss: []
    }
}
